import {
    GET_GROUP_LIST,
    REMOVE_GROUP_LIST,
    GET_MISC_CONTRACT,
    REMOVE_MISC_CONTRACT,
    SET_APP_CODE,
    SET_APP_ROUTE
} from "../../types";

import {
    YesNoList,
    YesNoBlankList,
    getStateList,
    YesNoListText,
    UtilityTypes
} from "../../../helpers/OptionList";

import {getCountryList} from "../../../helpers/CountryList";

const initialState = {
    groups: [],
    contracts: [],
    YesNoList: YesNoList(),
    YesNoListText: YesNoListText(),
    YesNoBlankList: YesNoBlankList(),
    StateList: getStateList(),
    CountryList: getCountryList,
    UtilityTypes: UtilityTypes(),
    APP: {
        NAME: process.env.APP_NAME,
        CLIENT: process.env.APP_CLIENT,
        NAV_GROUPS_TEXT: process.env.NAV_GROUPS_TEXT,
        NAV_GROUPS_ICON: process.env.NAV_GROUPS_ICON,
        BUDGET_INITIAL_PERIOD: process.env.APP_BUDGET_INITIAL_PERIOD,
        BUDGET_RENEWAL_PERIOD: process.env.APP_BUDGET_RENEWAL_PERIOD,
        CODE: process.env.APP_CLIENT,
        MARKETING_URL: process.env.APP_MARKETING_URL,
        CONTRACTOR: process.env.APP_CONTRACTOR, //	TODO: fetch this from backend since it changes on each client
        ROUTE: {
            component: null,
            verb: null,
            componentID: null
        }
    }
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_GROUP_LIST: {
            return {
                ...state,
                groups: [...payload]
            };
        }
        case SET_APP_CODE: {
            return {
                ...state,
                APP: {
                    ...state.APP,
                    CODE: payload
                }
            };
        }
        case SET_APP_ROUTE: {
            return {
                ...state,
                APP: {
                    ...state.APP,
                    ROUTE: {
                        ...state.APP.ROUTE,
                        ...payload
                    }
                }
            };
        }
        case REMOVE_GROUP_LIST:
            return {
                ...state,
                groups: []
            };
        case GET_MISC_CONTRACT:
            return {
                ...state,
                contracts: [...payload]
            };
        case REMOVE_MISC_CONTRACT:
            return {
                ...state,
                contracts: []
            };

        default:
            return state;
    }
}
